import config from '../config.json';

const API_BASE = config.api_base || '';

const fetchJSON = async (url, options = {}) => {
  const fullUrl = `${API_BASE}${url}`;

  try {
    const response = await fetch(fullUrl, {
      ...options,
      credentials: 'include',  // Critical for session cookies
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      }
    });

    if (!response.ok) {
      // Try to parse error as JSON, but handle non-JSON responses
      try {
        const error = await response.json();
        throw new Error(error.error || 'Request failed');
      } catch {
        throw new Error(`Request failed with status ${response.status}`);
      }
    }

    return response.json();
  } catch (error) {
    // Network errors or other fetch failures
    if (error.message.includes('fetch')) {
      throw new Error('Unable to connect to server');
    }
    throw error;
  }
};

export const checkSession = () => fetchJSON('/session');

export const login = (idToken) => fetchJSON('/login', {
  method: 'POST',
  body: JSON.stringify({ idToken })
});

export const logout = () => fetchJSON('/logout');

// The listed apps and games from server/apps.json. See docs/apps.md.
export const getApps = () => fetchJSON('/apps/manifest');

export const sendChatMessage = (messages) => fetchJSON('/sql-trainer/chat', {
  method: 'POST',
  body: JSON.stringify({ messages })
});
